import Swal from 'sweetalert2';
import $http from '../../../axios-instance';
import $http_wor from '../../../axios-instance-wor';

/**
 * Obtener capacitaciones.
 */
export async function fetchTrainings({state, commit}, reset_page = false) {

    if (reset_page) {
        commit('resetPageParams');
    }

    commit('dashboard/load', true, {root: true});

    await $http_wor.get('trainings/' + state.params.company_id, {params: state.params})
        .then(async (response) => {
            commit('setTrainings', response.data.data);
            commit('dashboard/load', false, {root: true});
        }).catch(error => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Obtener capacitación.
 */
export async function getTraining({state, commit}, id) {

    commit('dashboard/load', true, {root: true});

    await $http_wor.get('trainings/' + state.params.company_id + '/' + id,)
        .then(async (response) => {
            commit('setTraining', response.data.data);
            commit('dashboard/load', false, {root: true});
        }).catch(error => {
            //console.error(error)
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Obtener última capacitación.
 */
export async function getLastTraining({state, commit}) {

    commit('dashboard/load', true, {root: true});

    await $http_wor.get('trainings/last/' + state.params.company_id)
        .then(async (response) => {
            commit('setCodeToTraining', response.data.data.code);
            commit('dashboard/load', false, {root: true});
        }).catch(error => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Crear capacitación.
 */
export async function addTraining({state, commit, dispatch}) {

    commit('dashboard/load', true, {root: true});

    await $http_wor.post('trainings/' + state.params.company_id, state.training)
        .then(async (response) => {
            commit('dashboard/load', false, {root: true});
            await dispatch('fetchTrainings');

            commit('setModalShow', false);

            await Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Muy bien!',
                text: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });

        }).catch(async error => {
            commit('dashboard/load', false, {root: true});
            await Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: error.message,
                showConfirmButton: false,
                timer: 2000
            });

        });
}

/**
 * Actualizar capacitación.
 */
export async function updateTraining({state, commit, dispatch}) {

    commit('dashboard/load', true, {root: true});

    await $http_wor.put('trainings/' + state.params.company_id + '/' + state.training.id, state.training)
        .then(async (response) => {
            commit('dashboard/load', false, {root: true});
            await dispatch('fetchTrainings');
            commit('setModalShow', false);

            await Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Muy bien!',
                text: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });
        }).catch(async error => {
            commit('dashboard/load', false, {root: true});
            await Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: error.message,
                showConfirmButton: false,
                timer: 2000
            });

        });
}

/**
 * Eliminar capacitación.
 */
export async function deleteTraining({commit, state, dispatch}, id) {

    await Swal.fire({
        title: 'Eliminar',
        text: '¿Está seguro de eliminar la Capacitación?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Si, eliminar'
    }).then(async (result) => {
        if (result.value) {

            commit('dashboard/load', true, {root: true});

            await $http_wor.delete('trainings/' + state.params.company_id + '/' + id)
                .then(async (response) => {

                    await dispatch('fetchTrainings');
                    await Swal.fire({
                        position: 'center',
                        icon: 'success',
                        title: 'Muy bien!',
                        text: response.data.message,
                        showConfirmButton: true,
                        timer: 2000
                    });

                }).catch((error) => {

                    commit('dashboard/load', false, {root: true});
                    Swal.fire({
                        position: 'center',
                        icon: 'error',
                        title: error.message + '<br> ' + error.errors,
                        showConfirmButton: true,
                        timer: 5000
                    });
                });
        }
    });
}

/**
 * Obtener empresas.
 */
export async function fetchCompanies({commit, state, rootState}, filter) {

    if (!rootState.dashboard.loading && filter && filter.length > 2) {
        commit('dashboard/load', true, {root: true});

        let params = {
            nombre: filter
        };

        await $http.get('/empresas/lista', {params})
            .then((response) => {
                commit('setCompanies', response.data.data);
                commit('dashboard/load', false, {root: true});
            })
            .catch(() => {
                commit('dashboard/load', false, {root: true});
            });
    }
}

/**
 * Obtener Proveedores.
 */
export async function fetchTrainingCompanies({state, commit}, company_id) {

    commit('dashboard/load', true, {root: true});

    await $http_wor.get('training-companies/' + company_id, {params: {paginate: 0}})
        .then(async (response) => {
            commit('setTrainingCompanies', response.data.data);
            commit('dashboard/load', false, {root: true});
        }).catch(error => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Obtener Trabajadores.
 */
export async function fetchWorkers({state, commit,}, company_id) {

    commit('dashboard/load', true, {root: true});

    await $http_wor.get('workers/' + company_id, {params: {paginate: 0}})
        .then(async (response) => {
            commit('setWorkers', response.data.data);
            commit('dashboard/load', false, {root: true});

        }).catch(error => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Descargar plantilla
 */
export async function downloadTemplate({commit, state}) {

    commit('dashboard/load', true, {root: true});

    await $http_wor({
        url: '/trainings/download-template',
        method: 'GET',
        responseType: 'blob',
        params: {company_id: state.params.company_id}
    })
        .then(response => {
            commit('dashboard/load', false, {root: true});
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Plantilla Capacitaciones.xlsx');
            document.body.appendChild(link);
            link.click();
        })
        .catch(error => {
            commit('dashboard/load', false, {root: true});

            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: error.message,
                showConfirmButton: false,
                timer: 3000
            });
        });
}

/**
 * Subir archivo y crear EPPs masivamente.
 */
export async function uploadAndMassiveCreate({commit, state}) {
    let form_data = new FormData();

    for (let key in state.upload) {
        form_data.append(key, state.upload[key]);
    }

    commit('dashboard/load', true, {root: true});

    await $http_wor.post('/trainings/massive-creation/' + state.params.company_id, form_data)
        .then(async (response) => {
            commit('dashboard/load', false, {root: true});
            let errors = response.data.errors;

            if (errors.length) {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Error',
                    text: 'Existen inconsistencias en el archivo cargado',
                    showConfirmButton: false,
                    timer: 3000
                });

                errors.unshift({errores: 'errores'});
                let csv = '';
// Loop the array of objects
                for (let row = 0; row < errors.length; row++) {
                    let keysAmount = Object.keys(errors[row]).length;
                    let keysCounter = 0;

                    if (row === 0) {

                        for (let key in errors[row]) {

                            csv += key + (keysCounter + 1 < keysAmount ? ',' : '\r\n');
                            keysCounter++;
                        }
                    } else {
                        for (let key in errors[row]) {
                            csv += errors[row][key] + (keysCounter + 1 < keysAmount ? ',' : '\r\n');
                            keysCounter++;
                        }
                    }

                    keysCounter = 0;
                }

                let link = document.createElement('a');
                link.id = 'download-csv';
                link.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(csv));
                link.setAttribute('download', 'errores.csv');
                document.body.appendChild(link);
                document.querySelector('#download-csv').click();
            } else {
                await Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Muy bien!',
                    text: response.data.message,
                    showConfirmButton: true,
                    timer: 2000
                });
            }
        })
        .catch((error) => {

            commit('dashboard/load', false, {root: true});

            console.error(error);

            Notification.error({
                title: 'Error',
                message: 'Error al procesar el archivo',
                type: 'error',
                duration: 5000,
                customClass: 'notification-box',
            });
        });
}
